export default __webpack_public_path__ + "static/media/Stage2_saisyuu.054a0087.svg";